/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import UiBookingComponent from 'uplisting-frontend/components/ui/booking';

export default class UiBookingV2Component extends UiBookingComponent {}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::BookingV2': typeof UiBookingV2Component;
  }
}
